// Routes owned by the Settings module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const settingsPaths = {
    dataAccess: '/settings/data-access',
    dataAccessCreate: '/settings/data-access/new',
    dataAccessEdit: '/settings/data-access/:id/edit',
    // Unreferenced: referenced only by the commented-out nav entry in Settings/nav.ts; route is live.
    authorization: '/settings/authorization',
    // settings
    settings: '/settings',
    serviceTemplates: '/settings/service-templates',
    regulations: '/settings/regulations',
    productServiceManagement: '/settings/product-services',
} as const
